import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import { useGTMFetchErrorHandling } from './useGTMFetchErrorHandling'
import { GTM_API_LINK, WorkspacesData, gtmFetcher, gtmSWRErrorHandler, workspacesSchema } from 'lib/gtm'

export function useGTMWorkspaces(accountId: string | null, containerId: string | null, options?: SWRConfiguration) {
	const shouldFetch = Boolean(accountId && containerId)
	const workspacesFetcher = (url: string) => gtmFetcher({ url, schema: workspacesSchema })
	const { data, mutate, error } = useSWR<WorkspacesData>(
		shouldFetch ? `${GTM_API_LINK}/accounts/${accountId}/containers/${containerId}/workspaces` : null,
		workspacesFetcher,
		{
			...options,
			revalidateIfStale: false,
			onErrorRetry(_error, key, config, revalidate, revalidateOpts) {
				gtmSWRErrorHandler(_error, revalidate, revalidateOpts)
			},
		},
	)

	useGTMFetchErrorHandling(error)

	return {
		workspaces: data ? data.workspace ?? [] : null,
		mutateWorkspaces: mutate,
	}
}
